import { render, staticRenderFns } from "./DeadlinePage.vue?vue&type=template&id=6ad6d128&scoped=true&"
import script from "./DeadlinePage.vue?vue&type=script&lang=js&"
export * from "./DeadlinePage.vue?vue&type=script&lang=js&"
import style0 from "./DeadlinePage.vue?vue&type=style&index=0&id=6ad6d128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad6d128",
  null
  
)

export default component.exports